<template>
    <div>
        <modal class="new-modal-small" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto" width="1060" :min-width="200" :max-width="1060" :pivot-y="0.5" :adaptive="true" :scrollable="true" @closed="$emit('hideInvestmentHistory')">
            <div class="investment-history-header d-flex align-items-center justify-content-between">
                <span class="fw-600 text-white" style="font-size: 20px;">Investment History<span v-if="stakeholder_name"> - {{stakeholder_name}}</span></span>
                <span class="pointer" @click="hideModal">
                    <i class="icon icon-close text-white" style="font-size: 24px;"></i>
                </span>
            </div>
            <div class="investment-history-body">
                <table class="history-table w-100">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Shares Purchased</th>
                            <th>{{currency_symbol}} Invested</th>
                            <th>Reference</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="ajax_call_in_progress">
                            <td colspan="6">
                                <div class="d-flex align-items-center justify-content-center">
                                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="error_msg">
                            <td colspan="6" class="text-center fw-600 text-danger">{{error_msg}}</td>
                        </tr>
                        <tr v-else-if="investments.length == 0">
                            <td colspan="6" class="text-center fw-600">No Investments Yet!</td>
                        </tr>
                        <tr v-else v-for="(investment, index) in investments" :key="index">
                            <td class="text-secondary">{{index + 1}}</td>
                            <td>{{formatDate(investment.investment_date)}}</td>
                            <td>{{formatNumber(investment.shares_purchased)}}</td>
                            <td>{{investment.amount_invested != null ? currency_symbol + formatNumber(investment.amount_invested) : '-'}}</td>
                            <td>{{investment.reference_id || '-'}}</td>
                            <td class="text-center">
                                <el-dropdown trigger="click" placement="bottom-end" @command="handleAction($event, investment)">
                                    <span class="pointer px-2">
                                        <i class="icon icon-dots-vertical fs-20 text-secondary"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="view_notes">View Notes</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="!ajax_call_in_progress && investments.length">
                        <tr>
                            <td></td>
                            <td>Total</td>
                            <td>{{formatNumber(total_shares)}}</td>
                            <td>{{currency_symbol}}{{formatNumber(total_invested)}}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </modal>
    </div>
</template>

<script>
    import moment from 'moment';
    import { HalfCircleSpinner } from 'epic-spinners';
    import stakeholder from "../mixins/stakeholder.js"
    export default {
        props: ['modal_name', 'stakeholder_id', 'stakeholder_name'],
        mixins: [stakeholder],
        components: {
            HalfCircleSpinner
        },
        data() {
            return {
                ajax_call_in_progress: false,
                investments: [],
                api_total_shares: null,
                api_total_invested: null,
                error_msg: '',
            }
        },
        methods: {
            hideModal() {
                this.$modal.hide(this.modal_name);
                this.$emit('hideInvestmentHistory');
            },
            formatDate(value) {
                return value ? moment(value, 'YYYY-MM-DD').format('MMM D, YYYY') : '-';
            },
            handleAction(command, investment) {
                if (command == 'view_notes') {
                    this.$alert(investment.notes || 'No notes added', 'Notes', { confirmButtonText: 'OK', confirmButtonClass: 'investment-notes-ok-btn' });
                }
            },
            async getInvestments() {
                this.ajax_call_in_progress = true;
                this.error_msg = '';
                try {
                    let response = await this.getInvestmentHistory({ stake_holder_id: this.stakeholder_id });
                    // Data is normally at the top level, but also accept it wrapped in "response".
                    let data = response.investments ? response : (response.response || {});
                    this.investments = Array.isArray(data) ? data : (data.investments || []);
                    this.api_total_shares = data.total_shares != null ? data.total_shares : null;
                    this.api_total_invested = data.total_invested != null ? data.total_invested : null;
                }
                catch(err) {
                    console.log('Investment history error:', err);
                    this.investments = [];
                    this.error_msg = typeof err == 'string' ? err : (err && err.message) || 'Unable to load investment history';
                }
                this.ajax_call_in_progress = false;
            },
        },
        computed: {
            // Prefer the totals sent by the API; fall back to summing the rows.
            total_shares() {
                if (this.api_total_shares != null) return this.api_total_shares;
                return this.investments.reduce((total, x) => total + Number(x.shares_purchased || 0), 0);
            },
            total_invested() {
                if (this.api_total_invested != null) return this.api_total_invested;
                return this.investments.reduce((total, x) => total + Number(x.amount_invested || 0), 0);
            },
        },
        mounted() {
            this.getInvestments();
        },
    }
</script>

<style scoped>
    .investment-history-header {
        background-color: #1f3868;
        padding: 20px 32px;
    }
    .investment-history-body {
        background-color: #fff;
        max-height: 70vh;
        overflow-y: auto;
    }
    .history-table {
        border-collapse: collapse;
    }
    .history-table th {
        background-color: #f7f9fc;
        color: #7b8494;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        padding: 16px 32px;
    }
    .history-table td {
        color: #1f2937;
        font-size: 15px;
        padding: 20px 32px;
        border-bottom: 1px solid #eef1f5;
    }
    .history-table tfoot td {
        background-color: #1f3868;
        color: #fff;
        font-weight: 600;
        border-bottom: none;
        position: sticky;
        bottom: 0;
    }
</style>

<style>
    /* Element UI renders $alert outside this component, so this block is not scoped. */
    .el-button.investment-notes-ok-btn,
    .el-button.investment-notes-ok-btn:hover,
    .el-button.investment-notes-ok-btn:focus {
        background-color: #1f3868;
        border-color: #1f3868;
        color: #fff;
    }
    .el-button.investment-notes-ok-btn:hover {
        opacity: 0.9;
    }
</style>
